export default [
    {
		path: "/timetables",
		component: () => import("../views/Timetables/Home.vue"),
		meta: {
			hasmainmenu: true
		},
	},
	{
		// This is required to keep SessionManager happy after $router.replace()-ing only a route's query paramaters
		name: 'timetable-edit',	
		path: "/timetables/edit/:timetableid/:type?",
		component: () => import("../views/Timetables/Timetables/Edit.vue"),
		meta: {
			group: 'admin-timetable',
			hasmainmenu: true,
		},
	},
	{
		path: "/timetables/:timetableId/events/:eventId",
		component: () => import("../views/Timetables/Events/EditEvent.vue"),
		meta: {
			group: 'admin-timetable',
		},
	},
	{
		path: "/timetables/:timetableId/backgroundevents/:eventId",
		component: () => import("../views/Timetables/Events/EditBackgroundEvent.vue"),
		meta: {
			group: 'admin-timetable',
		},
	},
	{
		path: "/timetables/:timetableid/students",
		component: () => import("../views/Timetables/Students/Home.vue"),
		meta: {
			group: 'admin-timetable',
		},
	},
	{
		path: "/timetables/staff/:timetableid?",
		component: () => import("../views/Timetables/Timetables/StaffGrid.vue"),
	},
	{
		path: "/timetables/settings/:timetableid?",
		component: () => import("../views/Timetables/Timetables/EditSettings.vue"),
	},
	{
		path: "/timetables/import/:timetableid?",
		component: () => import("../views/Timetables/Timetables/Import.vue"),
	},
	{
		path: "/timetables/individual/:studentid?/:timetableid?",
		component: () => import("../views/Timetables/Timetables/Individual.vue"),
		meta: {
			group: 'admin-timetable',
		},
	},
	{
		path: "/timetables/individualteacher/:teacherid?/:timetableid?",
		component: () => import("../views/Timetables/Timetables/IndividualTeacher.vue"),
	},
	{
		path: "/timetables/roomusage/:timetableid?",
		component: () => import("../views/Timetables/Timetables/Rooms.vue"),
	},
	{
		path: "/timetables/time/:timetableid?/:programme?/:year?/:group?",
		component: () => import("../views/Timetables/Timetables/Time.vue"),
	},
    {
		path: "/timetables/placement-provider/:timetableid?/:programme?/:year?/:group?",
		component: () => import("../views/Timetables/Timetables/PlacementProvider.vue"),
	},
	{
		path: "/timetables/appointments/:timetableid?/:programme?/:year?/:group?",
		component: () => import("../views/Timetables/Timetables/Appointments.vue"),
	},
	{
		path: "/timetables/rooms",
		component: () => import("../views/Timetables/Rooms/Home.vue"),
	},
	{
		path: "/timetables/rooms/add",
		component: () => import("../views/Timetables/Rooms/Edit.vue"),
	},
	{
		path: "/timetables/rooms/:roomid?",
		component: () => import("../views/Timetables/Rooms/Edit.vue"),
	},
	{
		path: "/timetables/session-types",
		component: () => import("../views/Timetables/SessionTypes/Home.vue"),
	},
	{
		path: "/timetables/session-types/add",
		component: () => import("../views/Timetables/SessionTypes/Edit.vue"),
	},
	{
		path: "/timetables/session-types/:sessiontypeid?",
		component: () => import("../views/Timetables/SessionTypes/Edit.vue"),
	},
	{
		path: "/timetables/buildings",
		component: () => import("../views/Timetables/Buildings/Home.vue"),
	},
	{
		path: "/timetables/buildings/add",
		component: () => import("../views/Timetables/Buildings/Edit.vue"),
	},
	{
		path: "/timetables/buildings/:buildingid?",
		component: () => import("../views/Timetables/Buildings/Edit.vue"),
	},
	{
		path: "/timetables/templates",
		component: () => import("../views/Timetables/Templates/Home.vue"),
	},
	{
		path: "/timetables/templates/add",
		component: () => import("../views/Timetables/Templates/Edit.vue"),
	},
	{
		path: "/timetables/templates/:templateid?",
		component: () => import("../views/Timetables/Templates/Edit.vue"),
	},
	{
		path: "/timetables/absences",
		component: () => import("../views/Timetables/Absences.vue"),
	},
	{
		path: "/timetables/dateranges",
		component: () => import("../views/Timetables/DateRanges/Home.vue"),
	},
	{
		path: "/timetables/generator",
		component: () => import("../views/Timetables/Generator/Generator.vue"),
	},
	{
		path: "/timetables/generator/settings",
		component: () => import("../views/Timetables/Generator/Settings.vue"),
	},
    {
		path: "/timetables/upload",
		component: () => import("../views/Timetables/Upload.vue"),
	},
]
